import { useRef, useCallback } from 'react';

export function useScrollToDate() {
  const dateRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const getDateRef = useCallback(
    (date: string) => (el: HTMLDivElement | null) => {
      dateRefs.current[date] = el;
    },
    [],
  );

  const scrollToDate = useCallback((date: string) => {
    const el = dateRefs.current[date];
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return { getDateRef, scrollToDate };
}
